import publicDriverFactory from './Accordion.uni.driver';
import { dataHooks } from './constants';
import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export const accordionPrivateDriverFactory = (base: UniDriver) => {
  const getItemAt = (idx: number) =>
    base.$$(`[data-hook="${dataHooks.item}"]`).at(idx);

  return {
    ...publicDriverFactory(base),
    getAmountOfItems: async () =>
      base.$$(`[data-hook="${dataHooks.item}"]`).count(),
    hoverOnItem: async (idx: number) =>
      await getItemAt(idx).$('[data-hook="header"]').hover(),
    getAccordionItemAt: async (idx: number) => {
      const accordionItem = await getItemAt(idx);

      return accordionItemPrivateDriverFactory(accordionItem);
    },
  };
};

export const accordionItemPrivateDriverFactory = (base: UniDriver) => ({
  getToggleIconPlacement: async () => {
    const header = await base.get(`[data-hook="${dataHooks.header}"]`);
    const headerElement = (await header.getNative()) as HTMLElement;

    const isAtStart =
      headerElement.children[0].getAttribute('data-hook') ||
      headerElement.children[0].querySelector(
        `[data-hook="${dataHooks.toggleButton}"]`,
      );

    const isAtEnd =
      headerElement.lastElementChild?.getAttribute('data-hook') ||
      headerElement.lastElementChild?.querySelector(
        `[data-hook="${dataHooks.toggleButton}"]`,
      );

    return isAtStart ? 'start' : isAtEnd ? 'end' : 'none';
  },
});
